import React from 'react';
// import Link from 'react-router-dom/Link';
import { Row, Col, Anchor, Icon} from 'antd';
import './PatentHeader.css';

const PatentHeader = (props) => {
   return (
      <div className="PatentHeader--container">

      <div className="PatentHeader--container-inner">
        <div className="PatentHeader--subnavbar-container">
          <div className="PatentHeader--subnavbar center">
          </div>
          <h2 className="PatentHeader--subnavbar-headline font-special-heading">Real Time Touch: USPTO Patent Highlights</h2>
        </div>
        <div className="PatentHeader--headline">
        </div>
       <div className="PatentHeader--body-text center">
         <p>
           Real Time Touch: has a granted patent which could revolutionize telehealth and telemedicine.
         </p>
         {/* <p>
          Seeking partners to develop this innovative mobile health patent in a multibillion  dollar growing market.
         </p> */}

         <Row className="PatentHeader--row1">
          {/* <Col xs={22} sm={22} md={22} lg={22} style={{padding:20}}> */}
          <h5 className="color-highlight-headline">Powered Physical Displays on Mobile Devices</h5>
            <div className="PatentHeader--img-holder">
            <Anchor affix={false} offsetTop="70"><Anchor.Link href="#US9639150-Abstract" title={
              <img
                className="PatentHeader--img img-responsive img-rounded-more"
                src="https://www.realtimetouch.com/images/patents/med/US009639150-full-1.png"
                alt="Patent US009639150"
                />
              } /></Anchor>
                <div className="clearfix PatentHeader-text-subimg">USPTO Granted Patent US009639150</div>
            </div>
          {/* </Col>  */}
{/*
          <Col xs={22} sm={16} md={12} lg={12} style={{padding:20}}>
            <div className="PatentHeader--img-holder">
            <h5 className="color-highlight-headline">Remote Controlled Medication Dispenser</h5>

              <img
                className="PatentHeader--img img-responsive img-rounded-more"
                src="https://www.realtimetouch.com/images/patents/med/PCT62698688.jpg" alt="PCT62698688 - Remote Controlled Medication Dispenser"
                />

                <div className="clearfix PatentHeader-text-subimg">PCT Application No. PCT/US2019/042064</div>
            </div>
          </Col> */}

           <Col  xs={22} sm={16} md={12} lg={8} style={{padding:20}}>
            <div className="PatentHeader--img-holder">
            <h5 className="color-highlight-headline">Powered Physical Displays on Mobile Devices</h5>
            <Anchor affix={false} offsetTop="70"><Anchor.Link href="#20170195624-Abstract" title={
              <img
                className="PatentHeader--img img-responsive img-rounded-more"
                src="https://www.realtimetouch.com/images/patents/med/US020170195624A120170706-1.png"
                alt="Patent Appl. US020170195624A1"
              />
              } /></Anchor>
                <div className="clearfix PatentHeader-text-subimg">Patent Application US20170195624A1</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={24}>
              <p>Scroll down for more info</p>
              <Icon type="caret-down" className="Header--box-icon-caretdown" style={{ color:"#CE001B", fontSize:22 }} />
          </Col>
        </Row>

       </div>

      </div>
      </div>
    )
 }
 export default PatentHeader;


// WEBPACK FOOTER //
// ./src/common/PatentHeader/PatentHeader.js